var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-dropzone-container"},[_c('vue-dropzone',{attrs:{"id":"drop1","options":_vm.dropOptions,"data-cy":'dropzone'},on:{"vdropzone-file-added":_vm.afterAdded,"vdropzone-removed-file":_vm.afterRemoved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }